import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './ExploreUnknownAflamePortraitFlames.css';

function PortraitFlameLayers() {
  return (
    <div className="eu-aflame-portrait-flames" aria-hidden>
      <div className="eu-aflame-portrait-heat" />
      <div className="eu-aflame-portrait-flame eu-aflame-portrait-flame--left" />
      <div className="eu-aflame-portrait-flame eu-aflame-portrait-flame--center" />
      <div className="eu-aflame-portrait-flame eu-aflame-portrait-flame--right" />
      <div className="eu-aflame-portrait-rim" />
    </div>
  );
}

/**
 * Mission 68 general portrait flames — portaled on top of the avatar so they are not
 * hidden under hud3.png (avatar slot z-index 1, frame z-index 2).
 *
 * @param {{ anchorRef: React.RefObject<HTMLElement | null>, active?: boolean }} props
 */
export function ExploreUnknownAflamePortraitFlames({ anchorRef, active = true }) {
  const [anchorRect, setAnchorRect] = useState(null);

  useLayoutEffect(() => {
    if (!active) {
      setAnchorRect(null);
      return undefined;
    }
    const el = anchorRef?.current;
    if (!el) {
      setAnchorRect(null);
      return undefined;
    }

    const syncRect = () => {
      const node = anchorRef?.current;
      if (!node) {
        setAnchorRect(null);
        return;
      }
      const r = node.getBoundingClientRect();
      if (r.width < 1 || r.height < 1) {
        setAnchorRect(null);
        return;
      }
      setAnchorRect({
        top: r.top,
        left: r.left,
        width: r.width,
        height: r.height,
      });
    };

    syncRect();
    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(syncRect) : null;
    resizeObserver?.observe(el);
    window.addEventListener('resize', syncRect);
    window.addEventListener('scroll', syncRect, true);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', syncRect);
      window.removeEventListener('scroll', syncRect, true);
    };
  }, [active, anchorRef]);

  if (!active || !anchorRect || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className="eu-aflame-portrait-flames-portal-host"
      style={{
        top: `${anchorRect.top}px`,
        left: `${anchorRect.left}px`,
        width: `${anchorRect.width}px`,
        height: `${anchorRect.height}px`,
      }}
      aria-hidden
    >
      <PortraitFlameLayers />
    </div>,
    document.body
  );
}

export default ExploreUnknownAflamePortraitFlames;
